import { workflowLabels } from '@fv/client-core'
import { type Workflow, workflows } from '@fv/models'

import { AdminSliderPanel } from '@/components/AdminSliderPanel'
import {
  AdminToggleList,
  type ToggleListOption,
} from '@/components/shared/AdminToggleList'

import type { UsageStatSettings } from './types'

type Props = {
  isOpen: boolean
  onClose: () => void
  label: string
  settings: UsageStatSettings
  onChange: (settings: UsageStatSettings) => void
}

export const UsageStatConfig = ({
  isOpen,
  onClose,
  label,
  settings,
  onChange,
}: Props) => {
  const workflowOptions = workflows.map(workflow => ({
    value: workflow,
    label: workflowLabels[workflow],
    enabled: settings.workflows.includes(workflow),
  }))

  const handleWorkflowsChange = (list: ToggleListOption<Workflow>[]) => {
    if (!list.some(o => o.enabled)) return
    onChange({
      ...settings,
      workflows: list.filter(o => o.enabled).map(o => o.value),
    })
  }

  return (
    <AdminSliderPanel
      isOpen={isOpen}
      onClose={onClose}
      title={`${label} settings`}
    >
      <h3 className="font-semibold mb-2">Workflows</h3>
      <AdminToggleList
        list={workflowOptions}
        onChange={handleWorkflowsChange}
      />
    </AdminSliderPanel>
  )
}
